export const buildPath = (parts: (string | number)[]): string => {
    return parts.map((part) => `/${encodeURIComponent(part)}`).join('');
};
